import React, { useEffect, useRef } from "react";
import MessageItem from "./MessageItem";
import TypingIndicator from "./TypingIndicator";

function MessageList({
  messages,
  currentUserId,
  typingUsers,
  onDelete,
  onEdit,
  onReact,
  onReply,
  isGroup,
  onImageClick
}) {
  return (
   

      <div className="modern-message-wrapper">

    <div className="modern-messages-container">

      {messages.map((msg) => {

        const senderId =
          typeof msg.senderId === "object"
            ? msg.senderId?._id
            : msg.senderId;

        const isMe =
          String(senderId) === String(currentUserId);

        return (
          <div
            key={msg._id}
            className={`message-row ${isMe ? "me" : "other"}`}
          >
            <MessageItem
              message={msg}
              isMe={isMe}
              onDelete={onDelete}
              isGroup={isGroup}
              onEdit={onEdit}
              onReact={onReact}
              onReply={onReply}
              onImageClick={onImageClick}
            />
          </div>
        );
      })}

      {typingUsers &&
        Object.keys(typingUsers).length > 0 && (
          <TypingIndicator />
        )}
    </div>
  </div>
  );
}

export default MessageList;
